import React from 'react';
import { cn } from '@/utils/styles';
import { ChevronRightIcon } from '@/components/icons/ChevronRightIcon';
import { Separator } from '@design-system/Separator';
import { isHexColor } from '@utils/checkHexCode';
import { useNavigate } from 'react-router-dom';
import { EventTracker } from '@/utils';
import { formatConnectionLabel } from '@/utils/health/formatConnectionLabel';
export interface ConnectionItem {
  name: string;
  no_of_connections: number | 'No connections';
  connection_type_color: string;
  connection_type: string;
}

export interface HealthConnectionsListProps {
  connections?: ConnectionItem[];
  onViewAll: () => void;
  className?: string;
  onPage: string;
  isProUser?: boolean;
  'data-testid'?: string;
}

export const HealthConnectionsListCard: React.FC<
  HealthConnectionsListProps
> = ({
  connections,
  onViewAll,
  className,
  onPage,
  isProUser,
  'data-testid': testId,
}) => {
  const navigate = useNavigate();

  return (
    <div className={cn('rounded-xl w-full', className)} data-testid={testId}>
      {/* List of Connections */}
      <div>
        {connections?.map((item, index) => (
          <div key={`${index} - ${item.name}`}>
            <button
              onClick={() => {
                EventTracker.trackEvent(
                  onPage,
                  `${onPage}_HealthConnection_${encodeURIComponent(item.name)}`,
                );
                navigate(
                  `/health/connections/${encodeURIComponent(item.name)}`,
                );
              }}
              className="w-full flex items-center justify-between py-3 text-white focus:outline-none"
            >
              <div className="flex items-center mr-4">
                <span
                  style={{
                    backgroundColor: isHexColor(item.connection_type_color)
                      ? item.connection_type_color
                      : undefined,
                    boxShadow: isHexColor(item.connection_type_color)
                      ? `0 0 4px 2px ${item.connection_type_color}30`
                      : undefined,
                  }}
                  className={cn(
                    'w-1.5 h-1.5 shrink-0 rounded-full mr-3 shadow',
                    !isHexColor(item.connection_type_color) &&
                      item.connection_type_color,
                  )}
                ></span>
                <span className="typography-body text-left">{item.name}</span>
              </div>
              {/* Connections */}
              <span className="typography-caption1 dark text-secondary">
                {formatConnectionLabel(
                  typeof item.no_of_connections === 'number'
                    ? item.no_of_connections
                    : 0,
                  isProUser,
                )}
              </span>
            </button>
            <Separator className="bg-stroke-secondary-subtle h-[1px]" />
          </div>
        ))}
      </div>

      <button
        onClick={onViewAll}
        className="w-full text-left text-white typography-body mt-4 flex items-center justify-between"
      >
        {isProUser ? 'See all disease risks' : 'See all health connections'}
        <span className="text-tertiary">
          <ChevronRightIcon width={24} height={24} />
        </span>
      </button>
    </div>
  );
};
